"use client"

import type { getDictionary } from "@/get-dictionary"
import Image from "next/image"
import aboutUsHeroImage from "../../../../../../public/about-us-hero.webp"

type Props = {
  dictionary: Awaited<ReturnType<typeof getDictionary>>["aboutUs"]
}

function Desktop({ dictionary }: Props) {
  return (
    <section className="hidden h-[494px] w-full items-center justify-between bg-gradient-to-r from-brand-500 to-brand-700 text-secondary sm:flex">
      <div className="flex h-full max-w-[700px] shrink-[3] flex-col flex-wrap justify-evenly gap-4 px-8">
        <div>
          <span>{dictionary._heading}</span>
          <h1 className="mt-4 text-5xl">{dictionary._sub_heading}</h1>
        </div>
      </div>
      <div className="relative h-full w-[800px] shrink">
        <Image
          priority
          src={aboutUsHeroImage}
          fill
          alt="hero"
          sizes="(max-width: 572px) 100vw, 572px"
        />
      </div>
    </section>
  )
}

function Mobile({ dictionary }: Props) {
  return (
    <section className="flex w-full flex-col items-center gap-4 text-secondary sm:hidden">
      <div className="relative h-60 w-full bg-gradient-to-r from-brand-500 to-brand-700">
        <div className="absolute bottom-0 left-0 z-10 max-w-72 rounded-tr-lg p-4 shadow-xl backdrop-blur-2xl backdrop-filter">
          <span className="text-xs">{dictionary._heading}</span>
          <h1 className="text-lg">{dictionary._sub_heading}</h1>
        </div>
        <div className="relative float-right h-full w-full">
          <Image
            src={aboutUsHeroImage}
            fill
            alt="hero"
            sizes="(max-width: 240px) 100vw, 240px"
          />
        </div>
      </div>
    </section>
  )
}

export default function AboutUsHeroSection(props: Props) {
  return (
    <>
      <Desktop {...props} />
      <Mobile {...props} />
    </>
  )
}
